module.exports = __webpack_public_path__ + "static/media/icon-account.09f0e07f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-account.svg
// module id = 439
// module chunks = 11